import { render, staticRenderFns } from "./PasswordEditModal.vue?vue&type=template&id=2bfaf6e2&scoped=true"
import script from "./PasswordEditModal.vue?vue&type=script&lang=js"
export * from "./PasswordEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaf6e2",
  null
  
)

export default component.exports